<div class="c-select-create">
  <label v-if="label" :for="updatedLabel" class="txt-ellipsis bold">
    {{ updatedLabel && $t(updatedLabel) }}
    <span v-if="required" class="txt-danger txt-required">
      <span>*</span>
    </span>
  </label>

  <div
    @click="onSelect"
    v-outside="outsideClick"
    @keydown="handleKeyDown"
    @keydown.stop
    tabindex="0"
    :class="{'active' : isDropdown, 'outline-danger': isError, 'select-box-disabled' : readonly, 'c-select-created' : selectedValue.length}"
    class="row c-select"
  >
    <div class="c-option">
      <div class="select-valued">
        <span
          v-if="selectedValue.length"
          v-for="option in selectedValue"
          :style="!isIcon && 'padding-left: 7px;'"
          class="mr5 selected-value"
        >
          <span @click.stop @dblclick.stop @click="isDropdown = false">
            <c-icon
              v-if="isIcon"
              v-model:value="option.src"
              :isDelete="true"
              :readonly="readonly"
              :isArray="isArray"
            ></c-icon>
          </span>
          <span class="mr5">
            {{ option.value }}
          </span>
          <span 
            v-if="!readonly" 
            @click.stop="deleteOptionValue(option)"
          >
            &#x2715;
          </span>
        </span>
        <span v-else class="font15"
          >{{ $t('componentSelect') }} {{ updatedLabel && $t(updatedLabel)
          }}</span
        >
      </div>
      <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr0' : readonly && selectedValue.length}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i>
      <!-- <i
        :class="isDropdown ? 'icon-element-up':'icon-element-down', {'mr22' : readonly && selectedValue.length}"
        class="fa-angle-down fa bold ic-arrow-down"
      ></i> -->
      <!-- <button
        v-if="readonly && selectedValue.length"
        @click.stop
        @click="copyToClipboard"
        :tooltip="showPopup ? $t('componentCopied') : $t('componentCopy')"
        class="btn btn-danger btn-xs clone-icon tooltip mr3"
        style="right: 19px; top: 0px; height: 100%"
      >
        <i class="fa fa-clone"></i>
      </button> -->
    </div>
    <div v-if="isDropdown" :class="[isTop ? 'bottom-dropdown' : 'top-dropdown']" class="c-select-dropdown c-select-dropdown-active" @click.stop>
      <div class="c-select-dropdown-item" style="padding-bottom: 0px">
        <input
          v-if="searchable"
          @keyup.enter="onCreateKeySearch"
          v-model="keySearch"
          :ref='"keySearchQuery"'
          @click.stop
          :placeholder="$t('componentSearch')"
          type="text"
          class="input mb10"
        />
        <!-- <li v-if="searchable" @click="onCreateKeySearch" @click.stop class="font15" style="background: var(--gray-light);">{{ $t('componentCreateSelection') }} : <b>{{ keySearch }}</b></li> -->
        <div @click.stop class="row flex-footer mt10 mb15">
          <label :class="'txt-info bold font15 cursor'">
            <input
              type="checkbox"
              :checked="isCreateSelect"
              @change="toggleCreateSelect"
              class="input-checkbox"
            />
            {{ $t("componentCreateMore") }}
          </label>
          <c-button
            @handler="onCreateKeySearch"
            :isDisabled="!keySearch"
            class="btn btn-primary w100 ml10"
            value="componentSave"
            type="span"
          ></c-button>
        </div>
      </div>
    </div>
  </div>

  <p v-if="isError && showError" class="mb0 txt-danger font14 mt3">
    <span>{{ $t(isError) }}</span>
  </p>
</div>
